import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import ApiService from 'services/ApiService';

import { Style, Icon } from 'ol/style.js';
import { ToFeatures } from 'services/GeoJsonService';

export default class LayerTrafficHaza extends VectorLayer {

    constructor(map) {
        super({
            name: 'hazaLayer',
            source: new VectorSource(),
            style: (feature) => this.getDefaultStyle(feature),
            userLayer: true,
            layerIndex: 3,
        });
        this.map = map;
        this.map?.addLayer(this);
    }

    setData = function (data) {
        if(!data) return;
        const layer = this;
        let dataset = new Array();
        let id, name, x, y, wght, obj;
        for(let i = 0; i < data.rows.length; i++) {
            
            id = data.rows[i]['dggd'];
            name = data.rows[i]['dggdNm'];
            x = data.rows[i]['x'];
            y = data.rows[i]['y'];
            wght = data.rows[i]['wght'];
            
            obj = { id: id, x: x, y: y, nm: name, wght: wght, type: "haza" };
            dataset.push(obj);
        }

        const source = this.getSource()
        source.clear();
        source.addFeatures(ToFeatures(dataset))
    }

    getDefaultStyle = (feature) => {
        //가스, 유해화학물질, 위험물질, 폐기물,
        const id = feature.get('properties')['id'];
        let src = '/images/hazardous_materials_vehicle_horizontal.png';
        if(id == '가스') { src = '/images/car_gas.png' } 
        else if(id == '유해화학물질') { src = '/images/car_chemicals.png' } 
        else if(id == '위험물질') { src = '/images/car_dangerous.png' } 
        else if(id == '폐기물') { src = '/images/car_waste.png' }
        return new Style({
            image: new Icon({
                anchor: [0.5, 0.5],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: src,
                scale: 0.3,
            }),
            zIndex: 1
        })
    };
}